import { render, staticRenderFns } from "./OrgOnboardingStep3.vue?vue&type=template&id=c59a16ce&scoped=true"
import script from "./OrgOnboardingStep3.vue?vue&type=script&lang=js"
export * from "./OrgOnboardingStep3.vue?vue&type=script&lang=js"
import style0 from "./OrgOnboardingStep3.vue?vue&type=style&index=0&id=c59a16ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a16ce",
  null
  
)

export default component.exports